// extracted by mini-css-extract-plugin
export default {"StatusOption":"Status_StatusOption__wUgGj"};